import React from "react";
import styles from "./Sidebar.module.css";
import { mcn } from "../../../utils/mergeClassnames.js";
function Sidebar(props) {
    const { transparent } = props;
    return React.createElement("div", { className: mcn(transparent && styles.transparent) }, props.children);
}
export default Sidebar;
